import React, { useEffect, useState } from "react";
import "./index.scss";
import * as _ from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as Moment from "moment";
import { readRequesterSession } from "../../../store/requester/thunkAction";
import { useTranslation } from "react-i18next";
import { requesterActions } from "../../../store/requester/slice";

const Session = ({ config }) => {
  const { t } = useTranslation();
  const params = useParams();
  const userId = _.get(params, "id");
  const dispatch = useDispatch();

  const staffManage = useSelector((state) => state.staffManage);
  const requesterManage = useSelector((state) => state.requesterManage);
  const socketManage = useSelector((state) => state.socketManage);

  const [requester, setRequester] = useState({});
  const [isOnline, setIsOnline] = useState(false);

  const requesterStatusChange = _.get(
    socketManage,
    "requesterStatusChange",
    {},
  );
  const requesters = _.get(requesterManage, "requesters");
  const staff = _.get(staffManage, "staff", {});

  const staffId = _.get(staff, "_id");
  const session = _.get(config, "session");
  const isSearch = _.get(config, "isSearch", false);
  const navigate = useNavigate();
  const sessionId = _.get(session, "_id");
  const message = _.get(session, "lastMessage");
  const requesterId = _.get(session, "requesterId");
  const updateTime = _.get(session, "updateTime", 0);
  const staffSeenDetail = _.get(session, "staffSeenDetail", []);
  const requesterSession = _.get(session, "requester", {});
  const staffSeenAt = _.get(
    _.find(staffSeenDetail, { staffId: staffId }),
    "seenAt",
    0,
  );

  useEffect(() => {
    const requesterId = _.get(requesterSession, "_id");
    if (!isSearch && requesterId) {
      dispatch(requesterActions.setRequesters(requesterSession));
    }
  }, [dispatch, isSearch, requesterSession]);

  useEffect(() => {
    const requesterChangeId = _.get(requesterStatusChange, "requesterId");
    if (requesterChangeId && requesterChangeId === requesterId) {
      dispatch(readRequesterSession(requesterId));
    }
  }, [dispatch, requesterId, requesterStatusChange]);

  useEffect(() => {
    if (requesterId) {
      setRequester(requesters[requesterId] || {});
    }
  }, [dispatch, requesters, requesterId]);

  useEffect(() => {
    if (requester._id) {
      const isOnline = _.get(
        _.find(requester.attributes, { key: "isOnline" }),
        "value",
        false,
      );

      setIsOnline(isOnline);
    }
  }, [requester]);

  const timeAgo = (timestamp) => {
    const now = Moment();
    const time = Moment(timestamp);

    if (time.isAfter(now)) {
      return time.from(now);
    }
    return time.fromNow();
  };

  return (
    <div
      onClick={() => {
        navigate(`/chat/${userId}/message/session-id/${sessionId}`);
      }}
      style={{ width: "100%" }}
    >
      {!isSearch ? (
        <div className="d-flex gap-3" style={{ width: "100%" }}>
          <img
            width="20%"
            height="40px"
            className="rounded-circle mt-1"
            src="/img/chat/avatar.png"
            alt=""
            style={{
              maxWidth: "40px",
            }}
          />
          <div style={{ width: "80%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
              className="gap-2 justify-content-between align-items-center mb-1"
            >
              <div className="fw-medium one-line">
                {_.get(session, "name")}{" "}
                {session.isBot && (
                  <svg
                    title="Bot"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    fill="#6c757d"
                  >
                    <path d="M12 2a2 2 0 0 1 2 2c0 .74-.4 1.39-1 1.73V7h3a3 3 0 0 1 3 3v1h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1v1a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-1H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1v-1a3 3 0 0 1 3-3h3V5.73A2 2 0 0 1 10 4a2 2 0 0 1 2-2zm-3 9a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 0-3zm6 0a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 0-3zm-6 4.5h6v1H9v-1z" />
                  </svg>
                )}
              </div>
              <span className="color-gray small">
                {timeAgo(_.get(session, "updateTime"))}
                {staffSeenAt < updateTime && (
                  <span
                    style={{
                      height: "10px",
                    }}
                    className="color-info"
                  >
                    {" "}
                    ●
                  </span>
                )}
              </span>
            </div>
            <div
              className="text-content one-line color-gray"
              style={
                staffSeenAt < updateTime
                  ? {
                      fontWeight: "bold",
                      color: "black",
                      width: "100%",
                    }
                  : { width: "100%" }
              }
            >
              {message || "---"}
            </div>
            <div className="small">
              <span className={isOnline ? "color-info" : "text-warning"}>
                ●
              </span>{" "}
              {isOnline ? t("agent.nav.online") : t("agent.nav.offline")} ·
              {_.get(session, "domain")}
            </div>
          </div>
        </div>
      ) : (
        <div
          className="d-flex gap-3 align-items-center"
          style={{ width: "100%" }}
        >
          <img
            width="20%"
            height="40px"
            className="rounded-circle mt-1"
            src="/img/chat/avatar.png"
            alt=""
            style={{
              maxWidth: "40px",
            }}
          />
          <div
            style={{
              width: "80%",
            }}
            className="fw-medium one-line"
          >
            {_.get(session, "name")}
          </div>
        </div>
      )}
    </div>
  );
};

export default Session;
